import { useState } from "react";

import clsx from "clsx";

import { Switch } from "@components/shared/switch";
import { useUser } from "@components/user-context";
import { useFeatureFlags, useUpdateUserFeatureFlag } from "@hooks/http";
import { logEvent, prettyLogEvent } from "@internal/analytics";
import { Pages } from "@north-beam/nb-client-side/constants";
import Spinner from "@shared/spinner";

export const NewOverviewExperienceSwitch = ({
  switchClassname,
  basic,
}: {
  switchClassname?: string;
  basic?: boolean;
}) => {
  const { user } = useUser();

  const { hasFeatureFlag } = useFeatureFlags();
  const [updateUserFeatureFlag] = useUpdateUserFeatureFlag();

  const onNewOverviewPageExperience = !hasFeatureFlag(
    "doNotShowNewOverviewPage",
  );
  const overviewPageV2 = hasFeatureFlag("overviewPageV2");

  const [loading, setLoading] = useState(false);

  const toggleNewOverviewPageExperience = async (value: boolean) => {
    if (value === false) {
      logEvent("Turn off new overview page experience");
      if (overviewPageV2) {
        prettyLogEvent.onClick({
          user,
          page: Pages.OVERVIEW,
          domain: "Turn off new overview page experience",
        });
      }
    }

    setLoading(true);
    await updateUserFeatureFlag("doNotShowNewOverviewPage", !value);
    window.location.reload();
  };

  return (
    <div className="flex items-center">
      <div className={clsx("mr-2", { "text-xs text-[#717680]": !basic })}>
        Switch to {onNewOverviewPageExperience ? "old" : "new"} Overview page
        experience
      </div>
      {loading ? (
        <Spinner />
      ) : (
        <Switch
          size="small"
          value={onNewOverviewPageExperience}
          onChange={toggleNewOverviewPageExperience}
          labelClassname={switchClassname}
          id="feature-flag-tabs-and-flyout-switch"
        />
      )}
    </div>
  );
};
